module.exports = __webpack_public_path__ + "9e4dcac9bc6c27952184d22b0839634c.png";